<template>
  <template v-if="$props.bridge">
    <div class="d-flex mb-2 align-items-start flex-column">
      <div class="d-flex align-items-center">
        <img class="me-1" :src="require(`@/assets/icons/project/bridge/bridge-sel.svg`)" width="60" height="60">
        <span class="fw-bold text-violet me-1">
          {{ `D${$props.data.tooth[0].zone_number}/${$props.data.tooth[$props.data.tooth.length-1].zone_number}` }}
        </span>
        <img class="icon-3d" @click="callPreview3D(currentAsset?.id)" src="@/assets/icons/3d.svg" width="30" height="30" alt="3d">
      </div>
      <div class="d-flex align-items-center w-100">
        <div class="d-flex" @click="selected(toRaw($props.data.tooth))">
          <img v-show="! select" class="checkbox" src="@/assets/icons/checkbox.svg" width="20" height="20" alt="checkbox" style="background-color: white;"/>
          <img v-show="select" class="checkbox" src="@/assets/icons/checkbox-checked.svg" width="20" height="20" alt="checkbox-checked"/>
        </div>
        <div class="d-flex" style="min-width: 0;">
          <small ref="info" class="mx-2 text-truncate" data-bs-toggle="tooltip" data-bs-placement="top" :title="getFileName(currentAsset)">
            {{ getFileName(currentAsset) }}
          </small>
        </div>
      </div>
    </div>
  </template>
  <template v-else>
    <div class="d-flex mb-2 align-items-start flex-column">
      <div class="d-flex align-items-center">
        <img v-if="$props.isModel" class="me-2" :src="require(`@/assets/icons/model/${findIconByPrescriptionRows($props.data)}-sel.svg`)" width="60" height="60">
        <img v-else-if="! findIconByPrescriptionRows($props.data)[0].includes('teeth')" class="icon"
          :src="require(`@/assets/icons/project/${findIconByPrescriptionRows($props.data)}-sel.svg`)"
          :width="60"
          :height="60">
        <Teeth v-else
          :number="$props.data.zone_number"
          :selected="$props.data.selected"
          :width="60"
          :height="60"/>
        <img class="icon-3d" @click="callPreview3D(currentAsset?.id)" src="@/assets/icons/3d.svg" width="30" height="30" alt="3d">

        <small v-if="$props.isModel" class="ms-2" style="color: #E97B86;">{{ $props.data.name }}</small>
        <small v-else class="ms-2">PROGETTO</small>
      </div>
      <div class="d-flex align-items-center w-100">
        <div class="d-flex" @click="selected(toRaw([$props.data]))">
          <img v-show="! select" class="checkbox" :src="$props.isModel ? require('@/assets/icons/model/checkbox.svg') : require('@/assets/icons/checkbox.svg')" width="20" height="20" alt="checkbox" style="background-color: white;"/>
          <img v-show="select" class="checkbox" src="@/assets/icons/checkbox-checked.svg" width="20" height="20" alt="checkbox-checked"/>
        </div>
        <div class="d-flex" style="min-width: 0;">
          <small ref="info" class="mx-2 text-truncate" data-bs-toggle="tooltip" data-bs-placement="top" :title="getFileName(currentAsset)">
            {{ getFileName(currentAsset) }}
          </small>
        </div>
      </div>
    </div>
  </template>
</template>

<script>
import { ref, toRaw, watch, onMounted, computed } from 'vue';
import _head from "lodash/head";
import _find from "lodash/find";
import { Tooltip } from "bootstrap";
import { useI18n } from 'vue-i18n';
import { useAssets } from "@/composables/useAssets";
import Teeth from '@/components/Project/Teeth';


export default {
  name: "File",
  props: {
    data: {
      type: Object,
      required: true
    },
    asset: {
      type: Object,
      default: null
    },
    bridge: {
      type: Boolean,
      default: false
    },
    reset: {
      type: Boolean,
      default: false
    },
    isModel: {
      type: Boolean,
      default: false
    },
  },
  emits: [
    'assetsToRemove',
    'resetCompleted',
    'preview',
    'asset-model-to-remove',
  ],
  components: {
    Teeth
  },
  setup(props, {emit}) {
    const i18n = useI18n();
    const select = ref(false);
    const info = ref(null);
    const { findIconByPrescriptionRows } = useAssets();

    const currentAsset = computed(() => props.asset ?? props.data.assets?.[0] ?? null);

    onMounted(() => {
      new Tooltip(info.value);
    });

    watch(() => props.reset, (value) => {
      if (value) {
        select.value = false;
        emit('resetCompleted', false);
      }
    })

    const selected = (array) => {
      // Toggle icon.
      select.value = !select.value;

      // Models.
      if (_head(array).id === undefined) {
        let model = _head(array);
        let assetId = _head(model.assets)?.id;
        emit('asset-model-to-remove', assetId);
      } else {
        let dataRemove = {
          prescriptionRowsIds: [],
          assetsIds: []
        };

        const targetAssetId = currentAsset.value?.id;

        array.forEach((el) => {
          dataRemove.prescriptionRowsIds.push(el.id);
        });

        if (targetAssetId != null) {
          dataRemove.assetsIds.push(targetAssetId);
        }

        emit('assetsToRemove', dataRemove);
      }
    }

    const getFileName = (file) => {
      if (! file) return `${i18n.t('file not found')}`;
      return _find(file.media)?.file_name || `${i18n.t('file not found')}`;
    }

    const callPreview3D = (assetId) => {
      emit('preview', assetId);
    }

    return {
      findIconByPrescriptionRows,
      select,
      selected,
      toRaw,
      getFileName,
      callPreview3D,
      info,
      currentAsset,
    }
  }

}
</script>

<style scoped>
.icon-3d:hover,
.checkbox {
  cursor: pointer;
}
</style>
